//  ----------      START   IMPORT  BLOCK       ----------
import { Button, Form, Row, Col, Card } from "react-bootstrap";
import { Trash, Plus, ExclamationTriangle } from "react-bootstrap-icons";
import { useLanguage } from "../../../../../API/Context/LanguageContext";
import { VocabProOnboarding as Vocab} from "../../../../../ConfigFiles/multilingual/VocabProOnboarding";
import { EDUCATION_CONFIG } from "../../../../../ConfigFiles/maps/education_map";
import { EducationEnum } from "../../../../../Types/Enums/EducationEnum";
//  ----------      END   IMPORT  BLOCK       ----------

const StepQualifications = ({ data, update }) => {
  const { lan } = useLanguage();
  const currentYear = new Date().getFullYear();

  const proDegrees = EDUCATION_CONFIG.filter(item => item.id >= EducationEnum.BACHELORS);

  const updateQuals = (newArray) => update({ qualifications: newArray });

  // 🎯 STURDY VALIDATION LOGIC
  const getFieldError = (q, field) => {
    const val = q[field];
    if (field === 'year_of_completion') {
      const year = parseInt(val);
      if (!val) return true; 
      if (year < 1940 || year > currentYear + 10) return true;
      return false;
    }
    return !val || String(val).trim() === "";
  };

  const handleChange = (index, field, value) => {
    const updated = [...data.qualifications];
    if (field === 'year_of_completion') {
        // Only allow digits and max 4 chars
        value = String(value).replace(/\D/g, '').substring(0, 4);
    }
    updated[index] = { ...updated[index], [field]: value };
    updateQuals(updated);
  };

  const addQualification = () => {
    updateQuals([
      ...data.qualifications,
      { 
        id: crypto.randomUUID(),
        title: "", 
        institution: "", 
        category: EducationEnum.BACHELORS, // Starts at 4 (Bachelor's Degree)
        year_of_completion: "", 
        license: "", 
        deleted: false 
      }
    ]);
  };

  const removeQualification = (index) => {
    const updated = data.qualifications.filter((_, i) => i !== index);
    updateQuals(updated);
  };

  return (
    <div className="animate-in">
      <h4 className="mb-4 border-start border-primary border-4 ps-3">
        {Vocab.academic_history[lan]}
      </h4>

      {data.qualifications.map((q, index) => {
        const isTitleInvalid = getFieldError(q, 'title');
        const isInstInvalid = getFieldError(q, 'institution');
        const isYearInvalid = getFieldError(q, 'year_of_completion');

        return (
          <Card key={q.id || index} className={`mb-4 shadow-sm border-0 ${ (isTitleInvalid || isInstInvalid || isYearInvalid) ? 'border-start border-danger border-4' : 'bg-light'}`}>
            <Card.Body>
              <div className="d-flex justify-content-end mb-3">
                <Button 
                  variant="outline-danger" 
                  size="sm" 
                  className="rounded-circle border-0 p-0" 
                  onClick={() => removeQualification(index)}
                >
                  <Trash size={18} />
                </Button>
              </div>
              <Row className="g-3">
                <Col md={6}>
                  <Form.Label className="small fw-bold">{Vocab.education_title[lan]}</Form.Label>
                  <Form.Control
                    placeholder={Vocab.education_title_placeholder[lan]}
                    value={q.title}
                    isInvalid={isTitleInvalid}
                    onChange={(e) => handleChange(index, "title", e.target.value)}
                  />
                </Col>
                <Col md={6}>
                  <Form.Label className="small fw-bold">{Vocab.institution[lan]}</Form.Label>
                  <Form.Control
                    placeholder={Vocab.institution_placeholder[lan]}
                    value={q.institution}
                    isInvalid={isInstInvalid}
                    onChange={(e) => handleChange(index, "institution", e.target.value)}
                  />
                </Col>
                <Col md={4}>
                  <Form.Label className="small fw-bold">{Vocab.category[lan]}</Form.Label>
                  {/* ✅ Corrected option mapping */}
                  <Form.Select
                      value={q.category ?? EducationEnum.BACHELORS}
                      onChange={(e) => handleChange(index, "category", parseInt(e.target.value))}
                  >
                      {proDegrees.map((item) => (
                        <option key={item.id} value={item.id}>
                          {item.labels[lan] || item.labels[0]}
                        </option>
                      ))}
                  </Form.Select>
                </Col>
                <Col md={4}>
                  <Form.Label className="small fw-bold">{Vocab.year_of_completion[lan]}</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="YYYY"
                    value={q.year_of_completion}
                    isInvalid={isYearInvalid}
                    onChange={(e) => handleChange(index, "year_of_completion", e.target.value)}
                  />
                  <Form.Control.Feedback type="invalid">
                    {q.year_of_completion && parseInt(q.year_of_completion) < 1940 ? Vocab.year_must_be_greater[lan] : Vocab.required_value[lan]}
                  </Form.Control.Feedback>
                </Col>
                <Col md={4}>
                  <Form.Label className="small fw-bold">{Vocab.license[lan]}</Form.Label>
                  <Form.Control
                    placeholder="Cédula"
                    value={q.license}
                    onChange={(e) => handleChange(index, "license", e.target.value)}
                  />
                </Col>
              </Row>
            </Card.Body>
          </Card>
        );
      })}

      <Button 
        variant="outline-primary" 
        onClick={addQualification}
        className="w-100 py-3 border-dashed mb-4"
      >
        <Plus size={20} /> {Vocab.new_qualification[lan]}
      </Button>

      {data.qualifications.length === 0 && (
          <div className="alert alert-warning py-2 small">
              <ExclamationTriangle className="me-2" />
              {Vocab.please_add_qualification[lan]}
          </div>
      )}
    </div>
  );
};

export default StepQualifications;